import { Outlet } from "react-router-dom";

import { NvFooter, NvGnb } from "@/components/navigator";
import { useAuth } from "@/contexts/auth-context";
import { gnbTypeOf } from "@/lib/access";

// AI Agent Navigator page frame: GNB (4 types by access level) + page + Footer (Figma ver.3).
// Pages set their own background (most are #F5F5F2 or white).
export function NavigatorLayout() {
  const { user, accessLevel, logout } = useAuth();

  return (
    <div className="flex min-h-screen flex-col bg-nv-surface font-sans text-nv-text-primary">
      <NvGnb userType={gnbTypeOf(accessLevel)} userName={user?.requester_name} onLogout={logout} />
      <main className="flex flex-1 flex-col">
        <Outlet />
      </main>
      <NvFooter />
    </div>
  );
}
